module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "dedication"
    }
  }, [_c('h1', [_vm._v("Dedication")]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("To the headmaster and deputy headmaster of the school where I spent many happy and hard-working years: thank you for helping me fulfil my dreams.")]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("To my husband, children and wonderful grandchildren: thank you for your on-going love and support. You are my world. I love each of you so very much!")]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("To all teachers everywhere: Love your students, care for them like your own family, and never give up on trying to “find a way” to connect with them and inspire them.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ab9d586","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch002.vue
// module id = 66
// module chunks = 0